import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { ChatMessage } from "../data/types/chat";

interface PublicChatDraftState {
  messages: ChatMessage[];
  activeChatId: string | null;
  setDraft: (draft: { messages: ChatMessage[]; activeChatId: string | null }) => void;
  clearDraft: () => void;
}

/**
 * Holds the logged-out AI search transcript in `sessionStorage` so it
 * survives a same-tab detour through /login (e.g. an unauthenticated user
 * clicking "Compare") and back. The backend can't help restore this for an
 * anonymous user — `GET /chats/:id/messages` requires auth — so this has to
 * be a client-side draft.
 */
export const usePublicChatDraft = create<PublicChatDraftState>()(
  persist(
    (set) => ({
      messages: [],
      activeChatId: null,
      setDraft: ({ messages, activeChatId }) => set({ messages, activeChatId }),
      clearDraft: () => set({ messages: [], activeChatId: null }),
    }),
    {
      name: "public-chat-draft",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
